import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ShareUrlService} from '../../_services/share-url.service';

@Component({
  selector: 'app-view-pdf',
  templateUrl: './view-pdf.component.html',
  styleUrls: ['./view-pdf.component.css']
})
export class ViewPdfComponent implements OnInit {

  public pdfSrc: string;
  // viewUrl = 'https://docs.google.com/gview?url=%URL%&embedded=true';

  constructor(private shareUrlService: ShareUrlService) { }

  ngOnInit(): void {
    this.shareUrlService.currentDocumentUrl.subscribe(documentUrl => this.pdfSrc = documentUrl);
    console.log('file url::', this.pdfSrc);
  }

}
